import React from "react"
import OnBoardingImage from "../../assets/img/Onboarding.svg"
import Button from "../UIComponents/Button"
import { useProfile } from "../../contexts/ProfileContextProvider"
import { motion } from "framer-motion"

const variants = {
    hidden: {
        transition: { staggerChildren: 0.1, staggerDirection: -1 },
    },
    visible: {
        transition: { staggerChildren: 0.1, staggerDirection: 1 },
    },
    exit: {
        transition: { staggerChildren: 0.1, staggerDirection: 1 },
    },
}
const itemVariants = {
    hidden: {
        opacity: 0,
        y: 0,
        scale: 0.9,
        transition: {
            duration: 0.5,
        },
    },
    visible: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {
            type: "spring",
            stiffness: 250,
            velocity: 5,
            mass: 1,
            damping: 15,
        },
    },
    exit: {
        opacity: 0,
        y: -100,
        transition: {
            duration: 0.3,
        },
    },
}
const imgVariants = {
    hidden: {
        opacity: 0,
        scale: 0.9,
        y: 5,
        transition: {
            duration: 0.5,
        },
    },
    visible: {
        opacity: 1,
        scale: 1,
        y: 0,
        transition: {
            duration: 0.3,
        },
    },
    exit: {
        opacity: 0,
        y: -100,
        transition: {
            duration: 0.3,
        },
    },
}
const btnVariants = {
    hidden: {
        opacity: 0,
        scale: 0.9,
        y: 5,
        transition: {
            duration: 0.5,
        },
    },
    visible: {
        opacity: 1,
        scale: 1,
        y: 0,
        transition: {
            duration: 0.3,
        },
    },
    exit: {
        opacity: 0,
        y: 100,
        transition: {
            duration: 0.3,
        },
    },
}

const WelcomeSection = ({ handleToggleOptions }) => {
    const { contextSetHasOnBoarded } = useProfile()

    const handleClose = () => {
        contextSetHasOnBoarded(true)
    }
    const handleClick = () => {
        handleToggleOptions()
    }

    return (
        <motion.div
            variants={variants}
            initial="hidden"
            animate="visible"
            exit={"exit"}
            className="flex flex-1 flex-col justify-center overflow-hidden space-y-4 "
        >
            <motion.div
                variants={imgVariants}
                className="flex flex-1 p-4 relative overflow-hidden"
            >
                <img
                    className="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
                    src={OnBoardingImage}
                    alt="Welcome to hotspot"
                />
            </motion.div>

            <motion.div>
                <motion.h1
                    variants={itemVariants}
                    className="heading-1 text-center py-4"
                >
                    Hitta nya jobbmöjligheter!
                </motion.h1>
                <motion.p
                    variants={itemVariants}
                    className="text-center max-w-[65ch] mx-auto fg-color-3"
                >
                    Välkommen till Hotspot - din perfekta partner i jakten pả
                    spännande karriärmöjligheter! Upptäck en värld av nya
                    jobbmöjligheter skräddarsydda för studenter, direkt i din
                    handflata.
                </motion.p>
            </motion.div>

            <motion.div variants={btnVariants} className="flex center pb-safe">
                <div className="mx-auto w-full max-w-2xl flex gap-2 py-4 border-t border-primary-300 dark:border-neutral-700">
                    <Button
                        variant={"secondary"}
                        onClick={handleClose}
                        classes={"flex-1"}
                    >
                        Hoppa över
                    </Button>
                    <Button onClick={handleClick} classes={"flex-1"}>
                        Gå Vidare
                    </Button>
                </div>
            </motion.div>
        </motion.div>
    )
}

export default WelcomeSection
